export default __webpack_public_path__ + "static/media/Galapagospinguin.4975645b.jpg";